import React from 'react';
import { cn } from '../../../lib/utils';
import { Card } from '../../../components/ui/card';
import { FounderCardsProps } from '../types';

/**
 * Основатель — полосой во всю ширину: их бывает двое-трое, и сетка карточек
 * оставляла бы половину экрана пустой. Слева имя и доля, справа путь денег:
 * вложил → возвращено → долг → прибыли получено → доступно взять.
 */
export function FounderCards({ isDark, founders, formatMoney }: FounderCardsProps) {
  if (founders.length === 0) {
    return null;
  }

  const cardCls = cn(
    'rounded-2xl border-0 p-5 lg:p-6 transition-all duration-300',
    isDark ? 'bg-[#1A1A22] shadow-lg shadow-black/10' : 'bg-white shadow-lg shadow-slate-200/50',
  );

  const cell = (label: string, value: number, tone?: 'debt' | 'available') => (
    <div>
      <p className={cn('text-xs', isDark ? 'text-slate-400' : 'text-slate-500')}>{label}</p>
      <p
        className={cn(
          'text-base lg:text-lg font-bold mt-1',
          tone === 'debt' && value > 0 && 'text-amber-500',
          tone === 'available' && value > 0 && 'text-emerald-500',
          tone === 'available' && value < 0 && 'text-red-500',
          !(tone === 'debt' && value > 0) &&
            !(tone === 'available' && value !== 0) &&
            (isDark ? 'text-white' : 'text-[#111111]'),
        )}
      >
        {formatMoney(value)}
      </p>
    </div>
  );

  return (
    <div className="space-y-4">
      {founders.map((founder) => (
        <Card key={founder.payerId} className={cardCls}>
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
            <div className="lg:w-40 shrink-0">
              <h3 className={cn('text-lg font-bold', isDark ? 'text-white' : 'text-[#111111]')}>
                {founder.name}
              </h3>
              <p className={cn('text-xs mt-1', isDark ? 'text-slate-500' : 'text-slate-400')}>
                доля в прибыли {founder.profitShare}%
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-4 flex-1">
              {cell('Вложил', founder.contributed)}
              {cell('Возвращено', founder.reimbursed)}
              {cell('Долг перед ним', founder.debt, 'debt')}
              {cell('Прибыли получено', founder.profitTaken)}
              {cell('Доступно взять', founder.profitAvailable, 'available')}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
